import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import Form from "components/Form/Form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { createYupSchema } from "components/Form/utilities/yupSchemaGenerator";

const ReportCampaignForm = ({
  formContent, handleSubmit, error,
}) => {
  const [validationSchema, updateValidationSchema] = useState();

  useMemo(() => {
    let validationFields = [];
    formContent.forEach((inputRow) => {
      validationFields.push(...inputRow.fields);
    });
    validationFields = [].concat(...validationFields);

    const reducedFields = validationFields.reduce(createYupSchema, {});
    updateValidationSchema(reducedFields);
  }, [formContent]);

  const validationResolver = yup.object().shape(validationSchema);

  const methods = useForm({
    resolver: yupResolver(validationResolver),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  return (
    <FormProvider data-test="report-campaign-form" {...methods}>
      {error && (
        <div className="flash-message --danger mb-2" role="alert">
          <div className="w-100">
            <p className="mb-1">{error}</p>
          </div>
        </div>
      )}
      <Form handleSubmit={handleSubmit} formContent={formContent} key="reportCampaign" />
    </FormProvider>
  );
};

ReportCampaignForm.propTypes = {
  formContent: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default ReportCampaignForm;
